import revive_payload_client_sy8qKm6BDV from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_7n97xBwihT from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_WUVKAOHVTj from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_KqbYLVZkJN from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_a2etPkwdYl from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_rNKOTL8GCC from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_I83aWsHjVr from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_2xaxhYRYgN from "/app/node_modules/.pnpm/@pinia+nuxt@0.4.11_typescript@5.7.3_vue@3.5.13/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5K4h5g3qIi from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import bmui_6qgoJ5AxSg from "/app/plugins/bmui.ts";
import countdown_olk6LFpgGt from "/app/plugins/countdown.ts";
import directives_8CcCirWtnE from "/app/plugins/directives.ts";
import ga_client_7dQ7yMojeg from "/app/plugins/ga.client.ts";
import im_client_8ex9Cq7J7y from "/app/plugins/im.client.ts";
import inject_worker_client_9HnSu1iw9h from "/app/plugins/inject-worker.client.ts";
import request_host_PNNsgYv6Ze from "/app/plugins/request-host.ts";
import setup_client_LCITs7LDia from "/app/plugins/setup.client.ts";
import vue_platform_all_3ZnWe25KPs from "/app/plugins/vue-platform-all.ts";
import websocket_worker_client_woUwPoBAnW from "/app/plugins/websocket-worker.client.ts";
export default [
  revive_payload_client_sy8qKm6BDV,
  unhead_7n97xBwihT,
  router_WUVKAOHVTj,
  payload_client_KqbYLVZkJN,
  navigation_repaint_client_a2etPkwdYl,
  check_outdated_build_client_rNKOTL8GCC,
  chunk_reload_client_I83aWsHjVr,
  plugin_vue3_2xaxhYRYgN,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5K4h5g3qIi,
  bmui_6qgoJ5AxSg,
  countdown_olk6LFpgGt,
  directives_8CcCirWtnE,
  ga_client_7dQ7yMojeg,
  im_client_8ex9Cq7J7y,
  inject_worker_client_9HnSu1iw9h,
  request_host_PNNsgYv6Ze,
  setup_client_LCITs7LDia,
  vue_platform_all_3ZnWe25KPs,
  websocket_worker_client_woUwPoBAnW
]